import type { PublicSlotKey } from '#packages/apilib';
import type { HistoryApi } from './api';

export const HistoryApiKey: PublicSlotKey<HistoryApi> = {
  name: 'HistoryApi',
  public: true,
};
